import gql from 'graphql-tag'

export const getMessages = gql`
  query($paging: PagingQuery, $filter: MessagesFilter) {
    getMessages(
      paging: $paging,
      filter: $filter
    ) {
      messages {
        id
        content
        read
        createdAt
        masterId
        masterType
      }
    }
  }
`

export const markMessagesAsRead = gql`
  mutation($ids: [Int!]!) {
    markMessagesAsRead(
      messageIds: $ids
    )
  }
`
export const deleteMessageByIds = gql`
  mutation($messageIds: [Int!]!) {
    deleteMessageByIds(
      messageIds: $messageIds
    )
  }
`

export const vergeNotification = gql`
  subscription vergeNotification ($userId: Int!) {
    vergeNotification(userId: $userId) {
      id
      content
      read
      createdAt
      masterId
      masterType
    }
  }
`
